import { motion } from "framer-motion";
import { useState, useMemo } from "react";
import { ArrowUpRight, Star, Quote } from "lucide-react";
import { TESTIMONIALS } from "../lib/config";

const CATEGORIES = ["Tutte", "Gravidanza", "Personal Training"];

export default function Testimonials({ onBook }) {
    const [filter, setFilter] = useState("Tutte");
    const [active, setActive] = useState(0);

    const list = useMemo(
        () => (filter === "Tutte" ? TESTIMONIALS : TESTIMONIALS.filter((x) => x.category === filter)),
        [filter]
    );

    const t = list[active] || list[0];

    const changeFilter = (c) => {
        setFilter(c);
        setActive(0);
    };

    return (
        <section className="relative bg-powder py-24 md:py-40">
            <div className="max-w-[1600px] mx-auto px-5 md:px-12">
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10 md:mb-14">
                    <p className="text-xs uppercase tracking-[0.28em] font-sans text-ink-muted">
                        <span className="inline-block w-8 h-px bg-fuchsia align-middle mr-3" />
                        Testimonianze
                    </p>
                    <div className="flex flex-wrap gap-2">
                        {CATEGORIES.map((c) => (
                            <button
                                key={c}
                                data-testid={`testimonial-filter-${c.toLowerCase().replace(/\s+/g, "-")}`}
                                onClick={() => changeFilter(c)}
                                className={`rounded-full px-4 py-1.5 text-xs md:text-sm font-sans transition-all duration-300 ${
                                    filter === c
                                        ? "bg-fuchsia text-white"
                                        : "border border-ink/20 text-ink hover:border-fuchsia"
                                }`}
                            >
                                {c}
                            </button>
                        ))}
                    </div>
                </div>

                {t ? (
                    <motion.div
                        key={t.name + filter}
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.7 }}
                        className="max-w-5xl"
                    >
                        <Quote size={56} className="text-fuchsia/30 mb-2" />
                        <div className="flex items-center gap-3 mb-6">
                            <div className="flex gap-1">
                                {[...Array(5)].map((_, i) => (
                                    <Star key={i} size={18} className="fill-fuchsia text-fuchsia" />
                                ))}
                            </div>
                            <span className="text-[10px] uppercase tracking-[0.2em] font-sans bg-ink text-white px-3 py-1 rounded-full">
                                {t.category}
                            </span>
                        </div>
                        <blockquote className="font-serif italic text-3xl md:text-5xl lg:text-6xl leading-tight text-ink">
                            &ldquo;{t.quote}&rdquo;
                        </blockquote>
                        <div className="mt-8 flex items-center justify-between flex-wrap gap-4 border-t border-ink/10 pt-6">
                            <div>
                                <p className="font-sans font-semibold text-ink text-lg">{t.name}</p>
                                <p className="font-sans text-sm text-ink-muted">{t.role}</p>
                            </div>
                            <div className="flex gap-2">
                                {list.length > 1 && list.map((_, i) => (
                                    <button
                                        key={i}
                                        data-testid={`testimonial-dot-${i}`}
                                        onClick={() => setActive(i)}
                                        aria-label={`testimonial ${i + 1}`}
                                        className={`w-10 h-1 rounded-full transition-all duration-500 ${
                                            i === active ? "bg-fuchsia w-16" : "bg-ink/20"
                                        }`}
                                    />
                                ))}
                            </div>
                        </div>
                    </motion.div>
                ) : (
                    <p className="font-serif italic text-2xl text-ink-muted py-10">
                        Presto le testimonianze di questa categoria.
                    </p>
                )}

                <div className="mt-16 md:mt-24 text-center">
                    <button onClick={onBook} data-testid="testimonials-book-btn" className="btn-fuchsia">
                        Prenota una consulenza in presenza o online
                        <ArrowUpRight size={18} />
                    </button>
                </div>
            </div>
        </section>
    );
}
